module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v,
      "disabled": true
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _c('event-items', {
    attrs: {
      "discounted-products": _vm.event.discountedProducts,
      "special-promotions": _vm.event.specialPromotions,
      "event-start-date": _vm.event.startDate,
      "event-end-date": _vm.event.endDate,
      "customer-groups": _vm.customerGroups
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("\n        Special price event\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-59c9dce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ViewEvent/ViewEvent.vue
// module id = 1690
// module chunks = 1